import { updatesItems } from '@/mocks/homeData';

const tagStyles: Record<string, string> = {
  '最新': 'bg-primary-100 text-primary-700',
  '跟进': 'bg-accent-100 text-accent-700',
  '实锤': 'bg-primary-500 text-background-50',
  '数据': 'bg-secondary-100 text-secondary-700',
  '突发': 'bg-accent-500 text-background-50',
  '热帖': 'bg-primary-100 text-primary-700',
  '行业': 'bg-secondary-100 text-secondary-700',
  '独家': 'bg-accent-100 text-accent-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-timer-flash-line"></i>
            分秒必达
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">实时快讯</h2>
          <p className="text-foreground-600 text-sm">24小时滚动更新，不错过任何一条爆料</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative">
            <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-secondary-200 hidden md:block"></div>
            <div className="space-y-3">
              {updatesItems.map((item, i) => (
                <div key={i} className="flex items-start gap-3 md:gap-5 pl-0 md:pl-10 relative group cursor-pointer">
                  <div className="absolute left-[11px] w-2.5 h-2.5 rounded-full bg-primary-400 ring-4 ring-background-100 top-1.5 z-10 hidden md:block"></div>
                  <div className="flex-1 bg-background-50 rounded-lg p-3 md:p-4 border border-secondary-200/70 hover:border-primary-200 transition-all">
                    <div className="flex items-start justify-between gap-3">
                      <p className="text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors font-medium leading-relaxed flex-1">
                        {item.title}
                      </p>
                      <div className="flex items-center gap-2 flex-shrink-0">
                        <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${tagStyles[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                          {item.tag}
                        </span>
                      </div>
                    </div>
                    <span className="text-xs text-foreground-400 mt-2 block">{item.time}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}